import { faPlus, faVanShuttle } from '@fortawesome/pro-regular-svg-icons';
import clsx from 'clsx';
import { FunctionComponent, ReactNode } from 'react';
import styles from './TransportationIsEmpty.module.scss';
import Button from 'components/UI/V3/Button/Button';
import DefaultHeader from 'components/UI/V3/DefaultHeader/DefaultHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface TransportationIsEmptyProps {
    onClick?: () => void;
    className?: string;
    headerRightContent?: ReactNode;
}

const TransportationIsEmpty: FunctionComponent<TransportationIsEmptyProps> = props => {
    return (
        <div className={clsx(styles.baseContainer, props.className)}>
            <DefaultHeader
                title={'Transportation Services'}
                id="transportation_add_button"
                className={styles.header}
                customButton={props.headerRightContent}
            />
            <div className={styles.wrapper}>
                <div className={clsx(styles.icon)}>
                    <FontAwesomeIcon
                        icon={faVanShuttle}
                        aria-hidden="true"
                    />
                </div>
                <h1 className={clsx(styles.title)}>Transportation Services</h1>
                <p className={clsx(styles.paragraph)}>
                    Click the &quot;Add New Service&quot; button to add your first one
                </p>

                <div className={styles.buttonContainer}>
                    <Button
                        label="Add New Service"
                        size="large"
                        variant="primary"
                        leftIcon={faPlus}
                        onClick={props.onClick}
                    />
                </div>
            </div>
        </div>
    );
};

export default TransportationIsEmpty;
